import React from 'react';
import { MessageSquare } from 'lucide-react';
const cadSystems = ['OnShape', 'Fusion 360', 'SolidWorks'];
const erpSystems = ['SAP', 'NetSuite', 'Oracle ERP', 'Microsoft Dynamics', 'Thruline', 'Epicor', 'Infor', 'IFS', 'Sage', 'Acumatica', 'Odoo', 'SYSPRO'];
export function Integrations() {
  return <section className="py-24 px-6 bg-white" data-id="element-119">
      <div className="max-w-7xl mx-auto" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <h2 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-122">
            Works with your existing tools
          </h2>
          <p className="text-xl text-slate-600" data-id="element-123">
            Native integrations with all major CAD and ERP systems
          </p>
        </div>
        <div className="space-y-12" data-id="element-124">
          {/* CAD Systems */}
          <div data-id="element-125">
            <h3 className="text-sm font-semibold text-slate-500 mb-6" data-id="element-126">
              SUPPORTED CAD SYSTEMS
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto" data-id="element-127">
              {cadSystems.map((system, index) => <div key={index} className="bg-slate-50 rounded-lg p-4 border border-slate-200 text-center" data-id="element-128">
                  <div className="font-semibold text-slate-700 text-sm" data-id="element-129">
                    {system}
                  </div>
                </div>)}
              <a href="https://calendly.com/alex-thruline/learn-about-thruline" target="_blank" rel="noopener noreferrer" className="bg-blue-50 rounded-lg p-4 border-2 border-blue-200 text-center hover:bg-blue-100 transition-colors cursor-pointer group" data-id="element-130">
                <div className="flex items-center justify-center gap-2 text-blue-600 font-semibold text-sm" data-id="element-131">
                  <MessageSquare className="w-4 h-4" data-id="element-132" />
                  <span data-id="element-133">Request Another</span>
                </div>
              </a>
            </div>
          </div>
          {/* ERP Systems */}
          <div data-id="element-134">
            <h3 className="text-sm font-semibold text-slate-500 mb-6" data-id="element-135">
              ERP CONNECTORS
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4" data-id="element-136">
              {erpSystems.map((system, index) => <div key={index} className="bg-slate-50 rounded-lg p-4 border border-slate-200 text-center" data-id="element-137">
                  <div className="font-semibold text-slate-700 text-sm" data-id="element-138">
                    {system}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}